import SkeletonLoader from "../../../common/SkeletonLoader";

import {
    StyledDetailSheetTitleContainer,
    StyledDetailSheetDetailsContainer,
} from "./styles";

export const PdfContainerSkeletonLoader = (): JSX.Element => {
    return (
        <div data-testid="pdf-container-skeleton-loader">
            <SkeletonLoader height="200px" />
            <SkeletonLoader height="200px" />
            <SkeletonLoader height="200px" />
        </div>
    );
};

export const HeaderSkeletonLoader = (): JSX.Element => {
    return (
        <div data-testid="header-skeleton-loader">
            <SkeletonLoader width="200px" />
            <StyledDetailSheetTitleContainer>
                <SkeletonLoader height="40px" />
            </StyledDetailSheetTitleContainer>
            <StyledDetailSheetDetailsContainer>
                <SkeletonLoader height="100px" />
            </StyledDetailSheetDetailsContainer>
        </div>
    );
};

export const FooterSkeletonLoader = (): JSX.Element => {
    return <SkeletonLoader height="40px" />;
};
